<template>
  <AppHeader />

  <div class="container mx-auto p-4">
    <div
      class="max-w-3xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden
             text-gray-900 dark:text-gray-100"
    >
      <div class="p-4 border-b dark:border-slate-700">
        <h1 class="text-xl font-semibold text-gray-900 dark:text-gray-100">
          Registro de Entregas
        </h1>
      </div>

      <form class="p-4 space-y-4" @submit.prevent="submitForm">
        <div>
          <label class="block text-sm font-medium mb-1">Colaborador *</label>
          <input
            v-model.trim="form.collaborator"
            type="text"
            required
            readonly
            class="w-full px-3 py-2 border rounded-md focus:outline-none
                   bg-gray-100 dark:bg-slate-700 dark:text-gray-100 cursor-not-allowed
                   border-gray-300 dark:border-slate-700"
          />
        </div>

        <div>
          <label class="block text-sm font-medium mb-1">Data de Início *</label>
          <input
            v-model="form.start_date"
            type="datetime-local"
            required
            :max="today"
            :min="minStartDate"
            class="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-emerald-600
                   dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"
          />
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Período permitido: últimos 30 dias (sem lançamentos futuros).
          </p>
        </div>

        <div>
          <label class="block text-sm font-medium mb-1">Data de Conclusão *</label>
          <input
            v-model="form.finish_date"
            type="datetime-local"
            required
            :max="today"
            :min="minStartDate"
            class="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-emerald-600
                   dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"
          />
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Período permitido: últimos 30 dias (sem lançamentos futuros).
          </p>
        </div>

        <div v-if="form.unit === 'geof'">
          <label class="block text-sm font-medium mb-1">Processo *</label>
          <SearchSelect
            v-model="form.process"
            :options="processos_GEOF"
            option-label="label"
            option-value="id"
            placeholder="Pesquisar e selecionar…"
            clearable
          />

          <label class="block text-sm font-medium mb-1">Entrega *</label>
        <SearchSelect
          v-model="form.dispatch"
          :options="entregaDoProcesso"
          option-label="label"
          option-value="id"
          placeholder="Pesquisar e selecionar…"
          clearable
          />
          <label class="block text-sm font-medium mb-1">Tarefa *</label>
        <SearchSelect
          v-model="form.task"
          :options="tarefaDaAtividade"
          option-label="label"
          option-value="id"
          placeholder="Pesquisar e selecionar…"
          clearable
          />
        </div>
        <div v-else>
          <label class="block text-sm font-medium mb-1">Entrega *</label>
          <SearchSelect
            v-model="form.dispatch"
            :options="dispatches"
            option-label="entrega"
            option-value="entrega"
            placeholder="Pesquisar e selecionar…"
            clearable
          />
          <p v-if="!dispatches.length" class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Nenhuma entrega cadastrada para sua unidade.
          </p>
        </div>

        <div>
          <label class="block text-sm font-medium mb-1">Quantidade de itens *</label>
          <input
            v-model.number="form.items"
            type="number"
            min="1"
            required
            class="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-emerald-600
                   dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"
          />
          <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Padrão: 1 item por atividade.
          </p>
        </div>

        <div>
          <label class="block text-sm font-medium mb-1">Observações (Opcional)</label>
          <textarea
            v-model.trim="form.notes"
            rows="4"
            placeholder="Insira o valor aqui"
            class="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-emerald-600
                   dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"
          ></textarea>
        </div>

        <div class="pt-2">
          <fwb-button gradient="green-blue" outline class="px-4 py-2" :disabled="submitting">
            {{ submitting ? 'Enviando…' : 'Enviar' }}
          </fwb-button>
          <router-link to="/registros" class="ml-3 text-sm text-emerald-700 dark:text-emerald-300 hover:underline">
            Ver registros
          </router-link>
        </div>
      </form>
    </div>

    <div class="fixed top-4 right-4 z-50 space-y-2">
      <fwb-toast v-if="toast.success" type="success">Registro enviado com sucesso.</fwb-toast>
      <fwb-toast v-if="toast.error" type="danger">{{ toast.errorMessage }}</fwb-toast>
    </div>
  </div>

  <div class="flex justify-center mt-8">
    <!-- <AppFooter /> -->
  </div>
</template>

<script>
import axios from "axios";
import { FwbButton, FwbToast } from "flowbite-vue";
import AppHeader from "./Header.vue";
import SearchSelect from "./SearchSelect.vue";
//import AppFooter from "./Footer.vue" 
import { processos_GEOF, hierarquia_GEOF, weight_complexity_GEOF } from "./GEOF";
//import { useConfigStore } from "@/store";
//import { mapState } from "pinia";
//import { fromCodePoint } from "core-js/core/string";

export default {
  name: "dispatchForm",
  components: { FwbButton, FwbToast, AppHeader, SearchSelect },
  data() {
    return {
      form: {
        collaborator: "",
        unit: "",
        start_date: "",
        finish_date: "",
        dispatch: null,
        items: 1,
        notes: "",
        process: null,
        task: null,
        weight_points: null
      },
      dispatches: [],
      submitting: false,
      toast: { success: false, error: false, errorMessage: "" },
      apiBase: "/api",
      today: "",
      todayInterval: null,
      minStartDate: "",
      weight_complexity: '',
      processos_GEOF,
      hierarquia_GEOF,
      weight_complexity_GEOF,
      num_max_days: 3
    };
  },
  computed: {
  entregaDoProcesso() {
    if (!this.form.process) return []

    const proc = this.hierarquia_GEOF.find(p => p.id === this.form.process)

    return proc?.entrega || []
  },
  tarefaDaAtividade() {
    if (!this.form.process || !this.form.dispatch) return []

    const proc = this.hierarquia_GEOF.find(p => p.id === this.form.process)

    return proc?.tarefa || []
  },
},
  async created() {
    //Número de dias definido pelo adm
    await this.LoadMaxDays()

    //Calcular data de hoje
    this.refreshToday();                          
    this.todayInterval = setInterval(() => {      //Atualiza a cada minuto
      this.refreshToday();
    }, 60_000);

    this.form.finish_date = this.today

    this.fillCollaboratorFromUser();
    this.loadDispatches();
  },
  beforeUnmount() {
    clearInterval(this.todayInterval);
  },
  watch: {
    'form.process'() {
      this.form.dispatch = null
      this.form.task = null
    }
  },
  methods: {
    refreshToday() {
      //Calcular data de hoje
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const fmt = (d) =>
        `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
        `T${pad(d.getHours())}:${pad(d.getMinutes())}`;

      //Calcular data mínima (ajustável, porém padrão: 3 dias atrás)
      this.today = fmt(now);                           
      const min = new Date(now);
      min.setDate(min.getDate() - this.num_max_days);
      min.setHours(0, 0, 0, 0);
      this.minStartDate = fmt(min);                    
    },
    async LoadMaxDays() {
      const { data } = await axios.get(`${this.apiBase}/activities/num-days`)
      this.num_max_days = data.num_max_days
    },
    fillCollaboratorFromUser() {
      try {
        //Pega o usuário do localStorage (chave "user") e salva nome e email (se existirem)
        const u = JSON.parse(localStorage.getItem("user") || "{}");
        const name = (u?.name || "").trim();
        const email = (u?.email || "").trim();
        const unit = (u?.unit || "").trim();
        this.form.unit = unit.toLowerCase()
        if (name || email) {
          this.form.collaborator = name || email;
          return;
        }
      } catch (e) {
        console.debug("user parse failed", e);
      }

      const token = localStorage.getItem("token");
      if (!token) return;
      axios
        .get(`${this.apiBase}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(({ data }) => {
          const name = (data?.name || "").trim();
          const email = (data?.email || "").trim();
          this.form.collaborator = name || email || "";
        })
        .catch((e) => {
          console.debug("GET /auth/me failed", e);
          this.form.collaborator = this.form.collaborator || "";
        });
    },

    async submitForm() {
      //Cálculo das datas
      const now = new Date()
      const dt_begin = new Date(this.form.start_date);
      const difference_date = now - dt_begin
      const diff_min = Math.floor(difference_date / 1000/ 60)

      if (!this.form.collaborator.trim())
        return this.error("Não foi possível identificar o colaborador.");
      if (!this.form.start_date) return this.error("Selecione a data.");
      if (!this.form.dispatch) return this.error("Selecione a entrega.");
      if (!this.form.task && this.tarefaDaAtividade.length) return this.error("Selecione a tarefa.");
      if (dt_begin.getHours() < 7 || dt_begin.getHours() > 19)
        return this.error("Horário de início precisa estar dentro do regime normal de trabalho.");
      if (diff_min < 1) return this.error("A data de início da atividade não pode ser igual à data de conclusão da entrega");
      if (!Number.isInteger(this.form.items) || this.form.items < 1)
        return this.error("Quantidade de itens deve ser no mínimo 1.");

      if (this.form.start_date > now) return this.error("Não são permitidos lançamentos futuros.");
      if (this.form.start_date < this.minStartDate) return this.error(`Limite máximo: ${this.num_max_days} dias anteriores.`);

      if(this.form.unit === 'geof') {
        this.weight_complexity = hierarquia_GEOF
        .find(p => p.id === this.form.process)
        ?.entrega.find(e => e.id === this.form.dispatch)
        ?.complexity
        this.form.weight_points = weight_complexity_GEOF
        .find(p => p.complexity === this.weight_complexity).weight
      } 
      else {
        this.weight_complexity = ''
        this.form.weight_points = 1
      }
      

      this.submitting = true;
      try {
        await axios.post(
          `${this.apiBase}/activities`,
          {
            start_date: this.form.start_date,
            finish_date: this.form.finish_date,
            dispatch: this.form.dispatch,
            items: this.form.items,
            notes: this.form.notes,
            process: this.form.process,
            task: this.form.task,
            weight: this.form.weight_points
          },
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
        this.reset();
        this.toast.success = true;
        setTimeout(() => (this.toast.success = false), 2500);
      } catch (e) {
        console.error("POST /activities failed:", e?.response?.status, e?.response?.data);
        this.error(e?.response?.data?.error || "Erro ao enviar o registro.");
      } finally {
        this.submitting = false;
      }
    },

    async loadDispatches() {
      try {
        const { data } = await axios.get(`${this.apiBase}/unit-activities`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        this.dispatches = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error("GET /unit-activities failed", e?.response?.status, e?.response?.data);
        this.dispatches = [];
        this.error("Não foi possível carregar as entrega da sua unidade.");
      }
    },

    reset() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
      
      this.form.start_date = "";
      this.form.finish_date = fmt(now)
      this.form.dispatch = null;
      this.form.items = 1;
      this.form.notes = "";
      this.form.process = null;
      this.form.task = null;
    },

    error(msg) {
      this.toast.errorMessage = msg;
      this.toast.error = true;
      setTimeout(() => (this.toast.error = false), 2800);
    },
  },
};
</script>
